import React from "react";
import { Container, Row } from "react-bootstrap";
import { allExperiences } from "../constants/constants";

function Experience() {
  const experienceDiv = (
    designation,
    time,
    company,
    desc,
    icon = "/assets/projects.svg",
    companyLink
  ) => (
    <div
      key={company}
      className="exp-div"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      <img src={icon} alt="exp" className="exp-img" />
      <div className="exp-time">{time}</div>
      <div className="d-flex align-items-center">
        <h5 className="text-white bolder me-2">{designation}</h5>
        <div
          {...(companyLink && {
            role: "button",
            onClick: () => window.open(companyLink, "_blank"),
          })}
          className="d-flex align-items-center"
        >
          {company ? <h6 className="text-white-50 mb-0"> - {company}</h6> : ""}
          {companyLink ? (
            <img
              style={{ width: 15, height: 15 }}
              className="mb-1 ms-2"
              src="/assets/external-link.svg"
              alt="externalLink"
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="mt-3 text-white">{desc}</div>
    </div>
  );

  return (
    <Container>
      <Row className="my-5 pt-5">
        <h3
          className="bolder text-center text-white mb-5"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          Experience & Education
        </h3>
        <div>
          {allExperiences.map((exp) =>
            experienceDiv(
              exp.title,
              exp.tenure,
              exp.company,
              exp.description,
              exp.icon,
              exp.companyLink
            )
          )}
        </div>
      </Row>
    </Container>
  );
}

export default Experience;
